export {default as BeWizrActivityDocument} from './BeWizrActivityDocument'
export {default as BeWizrAgendaEndpoint} from './BeWizrAgendaEndpoint'